export function hasValue(mapping) {
    if (Array.isArray(mapping)) return !!mapping.length
    return !!mapping
}
